import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { authReducer } from "./auth/reducers";
import { userReducer } from "./user/reducer";
import { subjectReducer } from "./subjects/reducer";
import { chapterReducer } from "./chapters/reducer";
import { topicReducer } from "./topics/reducer";
import { subscriptionReducer } from "./subscription/reducer";
import { classReducer } from "./classes/reducer";

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    authReducer,
    userReducer,
    subjectReducer,
    chapterReducer,
    topicReducer,
    subscriptionReducer,
    classReducer,
  });

export default rootReducer;
